<!--
@Author: MIYONGLE
@Desc: 解决方案-及时配送行业
@Date: 2021-07-28 13时
-->
<template>
  <div class="page-main">
    <!-- 顶部 -->
    <mMenusNav><span>{{ titleName }}</span></mMenusNav>
    
    <!-- 背景 -->
    <div class="banner-box">
      <p class="title">
        <span>即时配送行业</span><br>
        <span>解决方案</span>
      </p>
      <p class="full-btn" @click="opearMth">立即咨询</p>
    </div>

    <!-- 场景诉求 -->
    <div class="appeal">
      <div class="title">场景诉求</div>
      <div class="appeal-left"></div>
      <div class="appeal-rigth"></div>
      <van-swipe class="content" :show-indicators="false" :autoplay="4000">
        <van-swipe-item>
          <div class="subtitle">
            <div class="qiye-img">
              <img src="../../../static/mobile/msolution/icon_solution_qiyesuqiu.png" alt="">
            </div>
            <p class="subtitle-title">企业诉求</p>
            <div class="icom-yleft">
              <img src="../../../static/mobile/msolution/icom_yinhao_1.png" alt="">
            </div>
            <div class="text">企业人力成本降低、获取合规票据</div>
            <div class="icom-yrigth">
              <img src="../../../static/mobile/msolution/icom_yinhao_2.png" alt="">
            </div>
            <div class="blue-tip"></div>
            <div class="cf-tip"></div>
            </div>
        </van-swipe-item>
        <van-swipe-item>
          <div class="subtitle">
            <div class="qiye-img">
              <img src="../../../static/mobile/msolution/icon_solution_qiyesuqiu1.png" alt="">
            </div>
            <p class="subtitle-title">配送人员诉求</p>
            <div class="icom-yleft">
              <img src="../../../static/mobile/msolution/icom_yinhao_1.png" alt="">
            </div>
            <div class="text">
              <p>为了多赚钱，到手钱多；</p>
              <p>意外受伤有保证</p>
              <p>老家有社保、新农合；获得尊重</p>
              </div>
            <div class="icom-yrigth2">
              <img src="../../../static/mobile/msolution/icom_yinhao_2.png" alt="">
            </div>
            <div class="cf-tip1"></div>
            <div class="blue-tip1"></div>
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>

    <!-- 即时配送行业解决方案 -->
    <div class="min-width-pc">
      <div class="title-txt">即时配送行业解决方案</div>
      <div class="product-text">
        「企业+平台+新个体」 <br> 新经济合作模式
      </div>
      <div class="line"></div>
      <p class="text">慧用工帮助灵活就业者注册成为新个体</p>
      <div class="solution-img">
        <img src="../../../static/mobile/msolution/img_solution_22.png" alt="">
      </div>

      <div class="product-text">
        个人向个体工商户转型 <br> 合理享受个人税收优
      </div>
      <div class="line"></div>
      <p class="text2">企业组织架构优化，降低人力用工成本，业务、票据、资金相匹配，银行监管，资金安全无忧</p>
      <div class="solution-img">
        <img src="../../../static/mobile/msolution/img_solution_23.png" alt="">
      </div>
    </div>

    <!-- 慧用工方案优势 -->
    <div class="advantage">
      <div class="title-txt">慧用工方案优势</div>
      <div v-for="item in advantageArry" :key="item.titleName" class="case-item">
          <img :src="item.src" alt="">
          <div class="text-box">
            <p class="title">{{item.titleName}}</p>
            <p>
              {{item.text}}
            </p>
          </div>
      </div>
    </div>
    <!-- form弹窗 -->
    <mFrom :source='source'></mFrom>
  </div>
</template>

<script type="text/javascript">
import mMenusNav from "../../components/mMenusNav";
import mFrom from "../../components/mFrom";
import {ADVANT_TAGEARRY} from "../../service/businessConsts";
export default {
  name: "app",
  data() {
    return {
      source: '',
      titleName: "即时配送行业",
      advantageArry:ADVANT_TAGEARRY,
    }
  },
  components: {
    mMenusNav: mMenusNav,
    mFrom: mFrom,
  },
  created() {
    // source来源：：
    let hash = window.location.hash;
    this.source = hash.indexOf('source') > 0 ? hash.substring(hash.indexOf('source')) + '&pageFrom=mjjfa_jsps' : '&pageFrom=mjjfa_jsps';
  },
  methods: {
    opearMth(){
      eventBus.$emit("operaDiaLog", true);
    },
  }
}
</script>

<style lang="scss" scoped>
.banner-box{
  width: 100%;
  height: 1080px;
  overflow: hidden;
  background-image: url(../../../static/mobile/msolution/banner_solution_2.png);
  // background-repeat:no-repeat;
  background-color: #100f0f;
  background-size:100%;
  .title{
    margin: 0 auto;
    margin-top: 463px;
    text-align: center;
    // width: 622px;
    height: 152px;
    font-size: 60px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #FFFFFF;
    line-height: 76px;
  }
  .full-btn{
    margin:0 auto;
    margin-top: 66px;
    width: 288px;
    height: 80px;
    background: #1985FF;
    border-radius: 40px;
    text-align: center;
    font-size: 30px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #FFFFFF;
    line-height: 80px;
  }
}
.appeal{
  margin: 0 auto;
  // width: 750px;
  width: 100%;
  height: 530px;
  overflow: hidden;
  position: relative;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0) 0%, rgba(25, 133, 255, 0.09) 100%);
  .title{
    margin:0 auto;
    margin-top: 70px;
    // width: 160px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .appeal-left{
    width: 500px;
    height: 270px;
    position: absolute;
    left: 30px;
    bottom: 0;
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(195, 209, 243, 0.95) 67%, rgba(195, 210, 245, 0) 100%);
  }
  .appeal-rigth{
    width: 500px;
    height: 270px;
    position: absolute;
    right: 30px;
    bottom: 0;
    background: linear-gradient(180deg, #FFFFFF 0%, rgba(195, 209, 243, 0.95) 67%, rgba(195, 210, 245, 0) 100%);
  }
  .content{
    position: absolute;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
    width: 590px;
    height: 351px;
    // background-color: red;
    background: linear-gradient(180deg, #FFFFFF 0%, #F1F5FD 100%);
    box-shadow: 0px -10px 84px -20px rgba(5, 50, 102, 0.07);
    .subtitle{
      margin-top: 46px;
      display: flex;
      justify-content: center;
      .qiye-img{
        width: 36px;
        height: 36px;
        img{
          width: 100%;
          height: 100%;
        }
      }
      .subtitle-title{
        margin-left: 10px;
        height: 38px;
        font-size: 28px;
        font-family: AlibabaPuHuiTi-Medium, AlibabaPuHuiTi;
        font-weight: 500;
        color: #171E2E;
        line-height: 38px;
      }
      .icom-yleft{
        position: absolute;
        left: 87px;
        top: 151px;
      }
      .icom-yrigth{
        position: absolute;
        right: 94px;
        bottom: 92px;
      }
      .icom-yrigth2{
        position: absolute;
        right: 94px;
        bottom: 35px;
      }
      .blue-tip{
        position: absolute;
        bottom: 20px;
        left: 281px;
        width: 16px;
        height: 6px;
        background: #1985FF;
        border-radius: 6px;
      }
      .cf-tip{
        position: absolute;
        bottom: 20px;
        left: 303px;
        width: 6px;
        height: 6px;
        background: #CFCFCF;
        border-radius: 6px;
      }
      .blue-tip1{
        position: absolute;
        bottom: 20px;
        left: 293px;
        width: 16px;
        height: 6px;
        background: #1985FF;
        border-radius: 6px;
      }
      .cf-tip1{
        position: absolute;
        bottom: 20px;
        left: 281px;
        width: 6px;
        height: 6px;
        background: #CFCFCF;
        border-radius: 6px;
      }
      .text{
        position: absolute;
        top: 187px;
        height: 33px;
        font-size: 24px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #706F6F;
        line-height: 33px;
      }
    }
  }
}
.min-width-pc{
  margin: 0 auto;
  width: 100%;
  // width: 750px;
  overflow: hidden;
  background-color: #FBFDFF;
  .title-txt{
    margin:0 auto;
    margin-top: 102px;
    // width: 400px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .product-text{
    margin:0 auto;
    margin-top: 53px;
    // width: 405px;
    padding: 0px 172.5px;
    height: 80px;
    text-align: center;
    font-size: 28px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #403F3F;
    line-height: 40px;
  }
  .line{
    margin: 0 auto;
    margin-top: 10px;
    width: 24px;
    height: 4px;
    background: #1985FF;
    border-radius: 4px;
  }
  .text{
    margin: 0 auto;
    margin-top: 10px;
    width: 473px;
    height: 30px;
    font-size: 22px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #403F3F;
    line-height: 30px;
  }
  .text2{
    margin: 0 auto;
    margin-top: 10px;
    // width: 345px;
    padding: 0px 157px;
    -webkit-text-size-adjust: none;
    // height: 40px;
    font-size: 14px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #403F3F;
    line-height: 20px;
  }
  .solution-img{
    margin: 0 auto;
    height: 342px;
    margin-top: 32px;
    margin-bottom: 72px;
    img{
      width: 100%;
      height: 100%;
    }
  }
}

.advantage{
  margin: 0 auto;
  width: 750px;
  height: 1130px;
  overflow: hidden;
  background: #FBFDFF;
  .title-txt{
    margin:31px auto 53px;
    // width: 280px;
    height: 56px;
    font-size: 40px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #100F0F;
    line-height: 56px;
  }
  .case-item{
    width: 690px;
    height: 208px;
    display: inline-flex;
    padding:30px 20px 0 30px;
    background: #FFFFFF;
    box-shadow: 0px 20px 60px -20px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;
    box-sizing: border-box;
    &:hover{
      position: relative;
      top:-5px;
      background-color: rgba(255, 255, 255, 1);
      box-shadow: 0px 20px 20px 0px rgba(16, 15, 15, 0.09);
    }
    img{
      width: 70px;
      height: 70px;
      vertical-align: top;
      margin-right:38px;
    }
    .text-box{
      line-height: 32px;
      color: #403F3F;
      font-weight: 400;
      font-size: 22px;
      text-align: left;
      .title{
        color: #403F3F;
        font-size: 28px;
        text-align: center;
        font-family: AlibabaPuHuiTi-Medium;
        font-weight: 500;
        text-align: left;
        line-height: 38px;
        margin-bottom: 20px;
      }
    }
  }
}


</style>


// WEBPACK FOOTER //
// src/views/mobile/mSolution_timelyDist.vue